export function formatScorecardDecimal(value: number | string | null | undefined): string {
  const numericValue = Number(value)
  if (Number.isNaN(numericValue)) {
    return '0'
  }

  const rounded = Math.round(numericValue * 100) / 100

  if (Number.isInteger(rounded)) {
    return String(rounded)
  }

  return rounded.toFixed(2).replace(/\.?0+$/, '')
}

export function formatScorecardPercent(value: number | string | null | undefined): string {
  return `${formatScorecardDecimal(value)}%`
}
